var map = {
	"./development/uploads/Company_Application_Form.pdf": 6389,
	"./development/uploads/Corporate_Packages.pdf": 98623,
	"./development/uploads/Individual_Application_Form.pdf": 77169,
	"./development/uploads/KYC_Ownership_Structure.pdf": 54755,
	"./development/uploads/KYC_UBO_Form.pdf": 46256,
	"./development/uploads/Source_Of_Funds_Form.pdf": 78863,
	"./development/uploads/UserRolesAndPermissions.pdf": 82348,
	"./swisstech/uploads/Company_Application_Form.pdf": 14071,
	"./swisstech/uploads/Corporate_Packages.pdf": 46169,
	"./swisstech/uploads/Individual_Application_Form.pdf": 38254,
	"./swisstech/uploads/KYC_Ownership_Structure.pdf": 6281,
	"./swisstech/uploads/KYC_UBO_Form.pdf": 38918,
	"./swisstech/uploads/Source_Of_Funds_Form.pdf": 17512,
	"./swisstech/uploads/UserRolesAndPermissions.pdf": 28257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28485;